type CountryWisePricingType = Record<
  string,
  {
    '1:1-retail-price': number
    '1:2-retail-price': number
  }
>

export const COUNTRY_WISE_PRICING: CountryWisePricingType = {
  USD: {
    // United States
    '1:1-retail-price': 12,
    '1:2-retail-price': 6,
  },
  INR: {
    // India
    '1:1-retail-price': 800,
    '1:2-retail-price': 400,
  },
  PKR: {
    // Pakistan
    '1:1-retail-price': 2100,
    '1:2-retail-price': 1050,
  },
  BDT: {
    // Bangladesh
    '1:1-retail-price': 920,
    '1:2-retail-price': 460,
  },
  LKR: {
    // Sri Lanka
    '1:1-retail-price': 2168,
    '1:2-retail-price': 1084,
  },
  MMK: {
    // Myanmar
    '1:1-retail-price': 19000,
    '1:2-retail-price': 9500,
  },
  KES: {
    // Kenya
    '1:1-retail-price': 1250,
    '1:2-retail-price': 625,
  },
  NGN: {
    // Nigeria
    '1:1-retail-price': 4500,
    '1:2-retail-price': 2250,
  },
  EGP: {
    // Egypt
    '1:1-retail-price': 189,
    '1:2-retail-price': 94,
  },
  ZAR: {
    // South Africa
    '1:1-retail-price': 320,
    '1:2-retail-price': 160,
  },
  IDR: {
    // Indonesia
    '1:1-retail-price': 173000,
    '1:2-retail-price': 86500,
  },
  PHP: {
    // Philippines
    '1:1-retail-price': 1100,
    '1:2-retail-price': 550,
  },
  VND: {
    // Vietnam
    '1:1-retail-price': 450000,
    '1:2-retail-price': 225000,
  },
  SGD: {
    //  Singapore
    '1:1-retail-price': 30,
    '1:2-retail-price': 15,
  },
  MYR: {
    // Malaysia
    '1:1-retail-price': 90,
    '1:2-retail-price': 45,
  },
  OMR: {
    // Oman
    '1:1-retail-price': 10,
    '1:2-retail-price': 5,
  },
  QAR: {
    // Qatar
    '1:1-retail-price': 80,
    '1:2-retail-price': 40,
  },
  SAR: {
    // Saudi Arabia
    '1:1-retail-price': 80,
    '1:2-retail-price': 40,
  },
  AED: {
    // United Arab Emirates
    '1:1-retail-price': 80,
    '1:2-retail-price': 40,
  },
  BHD: {
    // Bahrain
    '1:1-retail-price': 8,
    '1:2-retail-price': 4,
  },
  KWD: {
    // Kuwait
    '1:1-retail-price': 8,
    '1:2-retail-price': 4,
  },
  NPR: {
    // Nepal
    '1:1-retail-price': 1300,
    '1:2-retail-price': 650,
  },
  ETB: {
    // Ethiopia
    '1:1-retail-price': 600,
    '1:2-retail-price': 300,
  },
  CDF: {
    // Congo
    '1:1-retail-price': 16000,
    '1:2-retail-price': 8000,
  },
  MAD: {
    // Morocco
    '1:1-retail-price': 120,
    '1:2-retail-price': 60,
  },
  GHS: {
    // Ghana
    '1:1-retail-price': 77,
    '1:2-retail-price': 38.5,
  },
  GBP: {
    // United Kingdom
    '1:1-retail-price': 16,
    '1:2-retail-price': 8,
  },
  AUD: {
    // Australia
    '1:1-retail-price': 32,
    '1:2-retail-price': 16,
  },
  EUR: {
    // Euro
    '1:1-retail-price': 20,
    '1:2-retail-price': 10,
  },
  THB: {
    // Thailand
    '1:1-retail-price': 720,
    '1:2-retail-price': 360,
  },
  HUF: {
    // Hungary
    '1:1-retail-price': 7500,
    '1:2-retail-price': 3750,
  },
  PLN: {
    // Poland
    '1:1-retail-price': 96,
    '1:2-retail-price': 48,
  },
  RON: {
    // Romania
    '1:1-retail-price': 100,
    '1:2-retail-price': 50,
  },
}

export const COURSE_PRICE_COUNTRY_LINK = {
  IN: {
    PricePerSession: 'INR 800',
    coursePrice: 'INR 28,800',
    oneTimePrice: 'INR 25,920',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/cN2bKxbWncTK7gk28g',
    installmentPerMonth: 'INR 9,120',
    overallInstallmentPrice: 'INR 27,360',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/00g7uh3pRdXOcAE8wF',
  },
  US: {
    PricePerSession: 'USD 20',
    coursePrice: 'USD 720',
    oneTimePrice: 'USD 648',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZeeWD7a51UD7F65m6',
    installmentPerMonth: 'USD 228',
    overallInstallmentPrice: 'USD 684',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/aEUeWD51X0Qz8JacOz',
  },
  PK: {
    PricePerSession: 'PKR 2,100',
    coursePrice: 'PKR 75,600',
    oneTimePrice: 'PKR 68,040',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/aEU7ub7a57eX4sUeWI',
    installmentPerMonth: 'PKR 23,940',
    overallInstallmentPrice: 'PKR 71,820',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/5kA6q79id42L0cE4i5',
  },
  BD: {
    PricePerSession: 'BDT 920',
    coursePrice: 'BDT 33,120',
    oneTimePrice: 'BDT 29,808',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/14k7ubeCx1UDbVm6qe',
    installmentPerMonth: 'BDT 10,488',
    overallInstallmentPrice: 'BDT 31,464',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/eVag0H51XdDl8JaaGv',
  },
  LK: {
    PricePerSession: 'LKR 3,600',
    coursePrice: 'LKR 129,600',
    oneTimePrice: 'LKR 116,640',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/3csg0H1PL8j11gIaGw',
    installmentPerMonth: 'LKR 41,040',
    overallInstallmentPrice: 'LKR 123,120',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/bIY01J9id2YH9Ne5md',
  },
  KE: {
    PricePerSession: 'KES 1,650',
    coursePrice: 'KES 59,400',
    oneTimePrice: 'KES 53,460',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZeaGneCx1UDcZq01U',
    installmentPerMonth: 'KES 18,810',
    overallInstallmentPrice: 'KES 56,430',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/bIY01J9id2YH9Ne5md',
  },
  NG: {
    PricePerSession: 'NGN 6,150',
    coursePrice: 'NGN 221,400',
    oneTimePrice: 'NGN 199,260',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/8wMbKramheHp5wYaGA',
    installmentPerMonth: 'NGN 70,110',
    overallInstallmentPrice: 'NGN 210,330',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/dR6eWD7a5czhe3u6ql',
  },
  EG: {
    PricePerSession: 'EGP 350',
    coursePrice: 'EGP 12,600',
    oneTimePrice: 'EGP 11,340',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/14k5m3661eHpaRi6qm',
    installmentPerMonth: 'EGP 3,990',
    overallInstallmentPrice: 'EGP 11,970',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/dR6g0Hcupar99Ne163',
  },
  ZA: {
    PricePerSession: 'ZAR 340',
    coursePrice: 'ZAR 12,240',
    oneTimePrice: 'ZAR 11,016',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/14k29RgKFfLt4sU020',
    installmentPerMonth: 'ZAR 3,876',
    overallInstallmentPrice: 'ZAR 11,628',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/28o8yfdytfLt9Ne7ut',
  },
  SG: {
    PricePerSession: 'SGD 30',
    coursePrice: 'SGD 1,080',
    oneTimePrice: 'SGD 972',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/28o9CjfGB56P3oQ2aa',
    installmentPerMonth: 'SGD 342',
    overallInstallmentPrice: 'SGD 1,026',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/dR64hZ8e97eXcZqeWX',
  },
  MY: {
    PricePerSession: 'MYR 90',
    coursePrice: 'MYR 3,240',
    oneTimePrice: 'MYR 2,916',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/28odSzamh2YHf7ycOQ',
    installmentPerMonth: 'MYR 1,026',
    overallInstallmentPrice: 'MYR 3,078',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/4gwbKr6619n59Ne169',
  },
  QA: {
    PricePerSession: 'QAR 80',
    coursePrice: 'QAR 2,880',
    oneTimePrice: 'QAR 2,592',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/5kAcOv1PLgPx0cE5mq',
    installmentPerMonth: 'QAR 912',
    overallInstallmentPrice: 'QAR 2,736',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/14k4hZ1PLfLt7F6dSX',
  },
  SA: {
    PricePerSession: 'SAR 80',
    coursePrice: 'SAR 2,880',
    oneTimePrice: 'SAR 2,592',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZeeWDcupeHp3oQ4io',
    installmentPerMonth: 'SAR 912',
    overallInstallmentPrice: 'SAR 2,736',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/dR65m3bqldDlbVm8yF',
  },
  AE: {
    PricePerSession: 'AED 80',
    coursePrice: 'AED 2,880',
    oneTimePrice: 'AED 2,592',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/5kA15N7a50Qz0cEcOW',
    installmentPerMonth: 'AED 912',
    overallInstallmentPrice: 'AED 2,736',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/bIYaGndytbvd2kM7uD',
  },
  NP: {
    PricePerSession: 'NPR 1,300',
    coursePrice: 'NPR 46,800',
    oneTimePrice: 'NPR 4,120',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/8wMdSz1PL0Qz2kMeX6',
    installmentPerMonth: 'NPR 14,820',
    overallInstallmentPrice: 'NPR 44,460',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/eVa9CjgKF8j1f7y3ep',
  },
  ET: {
    PricePerSession: 'ETB 1,050',
    coursePrice: 'ETB 37,800',
    oneTimePrice: 'ETB 34,020',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZe3dV0LH2YHgbCaGS',
    installmentPerMonth: 'ETB 11,970',
    overallInstallmentPrice: 'ETB 35,910',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/fZebKr6611UDgbC6qD',
  },
  TH: {
    PricePerSession: 'THB 720',
    coursePrice: 'THB 25,920',
    oneTimePrice: 'THB 23,328',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/4gw5m30LH7eX0cEdT6',
    installmentPerMonth: 'THB 8,208',
    overallInstallmentPrice: 'THB 24,624',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/bIY8yf1PL0QzcZqbKZ',
  },
  EU: {
    PricePerSession: 'EUR 20',
    coursePrice: 'EUR 720',
    oneTimePrice: 'EUR 648',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZe3dV661fLt3oQ2aq',
    installmentPerMonth: 'EUR 228',
    overallInstallmentPrice: 'EUR 684',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/bIY29R9id0Qz1gIdT9',
  },
  GB: {
    PricePerSession: 'GBP 16',
    coursePrice: 'GBP 576',
    oneTimePrice: 'GBP 519',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/28ocOvfGB7eX3oQbL2',
    installmentPerMonth: 'GBP 183',
    overallInstallmentPrice: 'GBP 549',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/fZe4hZ7a542LbVm2at',
  },
  AU: {
    PricePerSession: 'AUD 32',
    coursePrice: 'AUD 1,152',
    oneTimePrice: 'AUD 1,037',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/aEU5m39idgPx0cEdTc',
    installmentPerMonth: 'AUD 365',
    overallInstallmentPrice: 'AUD 1,095',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/8wM8yf3XTfLt9Ne8yT',
  },
  HU: {
    PricePerSession: 'HUF 7,500',
    coursePrice: 'HUF 270,000',
    oneTimePrice: 'HUF 243,000',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZebKr8e942L2kM2aw',
    installmentPerMonth: 'HUF 85,500',
    overallInstallmentPrice: 'HUF 256,500',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/5kAbKramh42L5wYaH3',
  },
  PL: {
    PricePerSession: 'PLN 96',
    coursePrice: 'PLN 3,456',
    oneTimePrice: 'PLN 3,111',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/8wMeWD8e9ar9gbC5mK',
    installmentPerMonth: 'PLN 1,095',
    overallInstallmentPrice: 'PLN 3,285',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/6oE6q7fGBeHp9NedTh',
  },
  RO: {
    PricePerSession: 'RON 100',
    coursePrice: 'RON 3,600',
    oneTimePrice: 'RON 3,240',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/14k01JeCx56PgbCaH6',
    installmentPerMonth: 'RON 1,140',
    overallInstallmentPrice: 'RON 3,420',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/eVa7ubdytdDle3u4iJ',
  },
  /* Rest of the world */
  DEFAULT: {
    PricePerSession: 'USD 20',
    coursePrice: 'USD 720',
    oneTimePrice: 'USD 648',
    oneTimePaymentDiscount: 10,
    oneTimeBuyLink: 'https://buy.stripe.com/fZeeWD7a51UD7F65m6',
    installmentPerMonth: 'USD 228',
    overallInstallmentPrice: 'USD 684',
    discountPercent: 5,
    installmentBuyLink: 'https://buy.stripe.com/aEUeWD51X0Qz8JacOz',
  },
}
